import { BusinessUser } from '@models/businesses';
import { createSelector } from '@ngxs/store';
import { BusinessUsersState } from '@state/business-users/business-users.state';
import {
	EmailTemplateWithUser,
	EmailTemplateWithVersion,
} from '../email-templates.models';
import { BusinessEmailTemplatesStateModel } from './business-email-templates.models';
import { BusinessEmailTemplatesState } from './business-email-templates.state';

export class BusinessEmailTemplatesSelectors {
	static $getTemplates = createSelector(
		[BusinessEmailTemplatesState, BusinessUsersState.getUsers],
		(
			state: BusinessEmailTemplatesStateModel,
			users: BusinessUser[],
		): EmailTemplateWithUser[] => {
			return state.templates.map((template) => ({
				...template,
				source: 'business',
				createdByUser:
					users?.find((user) => user.id === template.createdBy) || null,
			}));
		},
	);

	static $getTemplatesDropdownOptions = createSelector(
		[BusinessEmailTemplatesSelectors.$getTemplates],
		(templates: EmailTemplateWithUser[]): { text: string; id: string }[] => {
			return templates.map((template) => ({
				text: template.templateName,
				id: template.id,
			}));
		},
	);

	static $getTemplateById = createSelector(
		[BusinessEmailTemplatesSelectors.$getTemplates],
		(
			templates: EmailTemplateWithUser[],
		): ((templateId: string) => EmailTemplateWithUser | null) => {
			return (templateId: string) =>
				templates.find((template) => template.id === templateId) || null;
		},
	);

	static $getTemplateByIdWithVersion = createSelector(
		[
			BusinessEmailTemplatesState,
			BusinessEmailTemplatesSelectors.$getTemplates,
		],
		(
			state: BusinessEmailTemplatesStateModel,
			templates: EmailTemplateWithUser[],
		): ((templateId: string) => EmailTemplateWithVersion) => {
			return (templateId: string) => {
				const metadata =
					templates.find((template) => template.id === templateId) || null;
				const version =
					metadata?.versionId && metadata.id
						? state.templateVersions[metadata.id]?.[metadata.versionId] || null
						: null;
				return { metadata, version, versionId: metadata?.versionId || null };
			};
		},
	);
}
